import type { JSX, ReactNode } from 'react';

import { Alert, AlertDescription } from '../../components/Alert/Alert';
import InnerContainer from '../../components/Layout/InnerContainer';
import LoadingIndicator from '../../components/LoadingIndicator/LoadingIndicator';
import { PageHeader } from '../../components/PageHeader/PageHeader';

import { useCanManageContracts } from './useCanManageContracts';

/**
 * Contract templates and the clause register are the team's to manage: only workspace
 * admins and owners open them. Anyone with Forms can still send a published contract
 * from a client's page.
 */
export function ContractsAdminOnly({ children }: { children: ReactNode }): JSX.Element {
  const { canManage, loading } = useCanManageContracts();
  if (loading) return <LoadingIndicator />;
  if (canManage) return <>{children}</>;
  return (
    <InnerContainer>
      <PageHeader title="Contracts" description="Contracts your clients sign online." />
      <Alert variant="warning">
        <AlertDescription>
          Only workspace admins and owners manage contract templates and the terms on client
          contracts. You can still send a contract from a client&apos;s page.
        </AlertDescription>
      </Alert>
    </InnerContainer>
  );
}
